import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';
import { modalsToggle, auctionVehiclesSetModal } from 'actions';
import ConfirmModal from 'components/Modals/ConfirmModal';
import moment from 'moment';
import { useViewedVehicle } from '../../../../../hooks/useViewedVehicle';
import { useNoSelectorVehicleOfferAuctionById } from '../../../../../../../../hooks';
import { ActionRow } from '../ActionRow';
import { formatCurrency } from 'utils';

const modalTitle = 'confirmApproveModal';
const chargeModalTitle = 'auctionDetailAwardBuyerModal';

export const HighestBid = () => {
  const currentVehicle = useViewedVehicle();
  const dispatch = useDispatch();
  const offerAuction = useNoSelectorVehicleOfferAuctionById(currentVehicle?.id || 0);

  const highestBid = currentVehicle?.highest_bid;

  if (!highestBid || !highestBid.bidder || !currentVehicle || !currentVehicle.proxy_bid) {
    return null;
  }

  const openApproveModal = () => {
    dispatch(modalsToggle(modalTitle));
  };

  const handleApprove = () => {
    const preSelectedBuyer = { value: highestBid.bidder.id, label: highestBid.bidder.dealership_name };
    const predefinedAwardPrice = highestBid.amount;
    dispatch(auctionVehiclesSetModal({ ...currentVehicle, preSelectedBuyer, predefinedAwardPrice }));
    dispatch(modalsToggle(modalTitle));
    dispatch(modalsToggle(chargeModalTitle));
  };

  const proxyBid = currentVehicle.proxy_bid || { amount: 0 };
  const isProxyHigherThanCurrentBid = proxyBid.amount >= highestBid.amount;
  const currentTime = moment.utc();
  const proxyOfferBid = offerAuction?.offerProxyBid;
  const showProxyOffer =
    proxyOfferBid && currentVehicle?.date_end && moment.utc(currentVehicle.date_end).isBefore(currentTime);
  return (
    <Fragment>
      <ActionRow
        label={`Highest Bid - ${formatCurrency(highestBid.amount)} (${highestBid.bidder.dealership_name})`}
        buttonConfig={{
          handleClick: openApproveModal,
          label: 'Approve'
        }}
      />
      {isProxyHigherThanCurrentBid && !showProxyOffer && (
        <ActionRow label={`Proxy Bid - ${formatCurrency(proxyBid.amount)}`} buttonConfig={null} />
      )}
      {showProxyOffer && (
        <ActionRow label={`Proxy Offer - ${formatCurrency(proxyOfferBid.amount)}`} buttonConfig={null} />
      )}
      <ConfirmModal
        submitText={'Submit'}
        modalId={modalTitle}
        title={
          <>
            You are about to approve the high bid of{' '}
            <NumberFormat displayType="text" prefix="$" value={highestBid.amount} thousandSeparator /> from{' '}
            {highestBid.bidder.dealership_name}.
          </>
        }
        handleSubmit={handleApprove}
      />
    </Fragment>
  );
};
